module.exports = __webpack_public_path__ + "static/media/service.c13b11cb.jpeg";